import { render, staticRenderFns } from "./DisbursementContract.vue?vue&type=template&id=4b7282e0&scoped=true&"
import script from "./DisbursementContract.vue?vue&type=script&lang=js&"
export * from "./DisbursementContract.vue?vue&type=script&lang=js&"
import style0 from "./DisbursementContract.vue?vue&type=style&index=0&id=4b7282e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7282e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VIcon,VSimpleTable})
